import createColorBlockPlugin from '../ColorBlock/plugin'

const colorBlockPlugin = createColorBlockPlugin({
  labelText: '+ ColorBlock',
  tooltipText: 'Add dem color blocks son!',
})

export const { AddColorBlockButton, blockRendererFn } = colorBlockPlugin

export const modifiers = {
  insertColorBlock: colorBlockPlugin.insertColorBlock,
}

export default [colorBlockPlugin]



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/plugins/colorBlock.js